module.exports = __webpack_public_path__ + "img/niue.90d2455d.svg";